
import { Tbl_mvpmeseEdit } from './tbl_mvpmeseEdit';
import { Tbl_mvpmeseList } from './tbl_mvpmeseList';
import { Tbl_mvpmeseShow } from './tbl_mvpmeseShow';
import { Tbl_mvpmeseCreate } from './tbl_mvpmeseCreate';
import MapIcon from '@material-ui/icons/Map';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: Tbl_mvpmeseList,
    edit: Tbl_mvpmeseEdit,
    show: Tbl_mvpmeseShow,
    create: Tbl_mvpmeseCreate,
    icon: MapIcon
};
            